import React from 'react';
import { Container, Spinner } from 'react-bootstrap';

function RouteFallback() {
  return (
    <Container className="py-5 text-center text-muted" aria-live="polite" aria-busy="true">
      <Spinner animation="border" size="sm" className="me-2" aria-hidden />
      <span className="visually-hidden">Loading</span>
    </Container>
  );
}

export default RouteFallback;
